export default __webpack_public_path__ + "static/media/LOGO_ATRAKCJA.12cc51c4.png";